import type { ComponentOverride } from '../types';

export const MuiDialogActions: ComponentOverride<'MuiDialogActions'> = {
  MuiDialogActions: {
    styleOverrides: {
      root: {
        padding: '0 12px 12px 12px',
      },
    },
  },
};
